<div class="branding-container">
  <app-branding-logo class="branding-column" />
</div>
